<template>
  <div>
    <div v-if="hasBindData.isExistCs">
      <el-card class="card-box">
        <el-row class="btn-group mb-16">
          <el-col :span="12">
            <el-button
              class="btn-item"
              type="primary"
              @click="handleBtn('add')"
              v-auth="'stores::shop-site::email-add'"
            >
              {{ $t('shop-site::email::add_button') }}
            </el-button>
          </el-col>
          <el-col :span="12" class="right-col">
            <el-input
              :placeholder="$t('shop-site::email::search_placeholder')"
              class="col-search-input"
              v-model="params.email"
              clearable
              @keyup.native.enter="() => search()"
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-col>
        </el-row>
        <z-table
          ref="table"
          v-loading="loading"
          :data="tableData"
          :columns="columns"
          :pagination.sync="pagination"
          @page-change="getListData"
        >
          <template #shopName="{ row }">
            <p class="oneline" :title="row.shopName">{{ $dataCheck(row.shopName) }}</p>
          </template>
          <template #inServer="{ row }">
            <div style="line-height: 30px">
              <p>{{ $t('shop-site::email::table_recieveType') }}：{{ $dataCheck(row.inAccountType) }}</p>
              <p>{{ $t('shop-site::email::table_recieveAddress') }}：{{ $dataCheck(row.inServer) }}</p>
              <p>{{ $t('shop-site::email::table_recievePort') }}：{{ $dataCheck(row.inPort) }}</p>
              <p>{{ $t('shop-site::email::table_protocol') }}：{{ $dataCheck(row.inProtocol) }}</p>
              <p>{{ $t('shop-site::email::table_reciever') }}：{{ $dataCheck(row.inUser) }}</p>
            </div>
          </template>
          <template #outServer="{ row }">
            <div style="line-height: 30px">
              <p>{{ $t('shop-site::email::table_sendType') }}：{{ $dataCheck(row.outAccountType) }}</p>
              <p>{{ $t('shop-site::email::table_sendAddress') }}：{{ $dataCheck(row.outServer) }}</p>
              <p>{{ $t('shop-site::email::table_sendPort') }}：{{ $dataCheck(row.outPort) }}</p>
              <p>{{ $t('shop-site::email::table_protocol') }}：{{ $dataCheck(row.outProtocol) }}</p>
              <p>{{ $t('shop-site::email::table_sender') }}：{{ $dataCheck(row.outUser) }}</p>
            </div>
          </template>
          <template #statusHeader>
            <div style="text-align: center">{{ $t('shop-site::email::table_status') }}</div>
          </template>
          <template #status="{ row }">
            <el-switch
              v-model="row.status"
              active-color="#0560fd"
              inactive-color="#E9E9E9"
              @change="val => onSwitchChange(row, val)"
            ></el-switch>
          </template>
          <template #createTime="{ row }">
            <p>{{ $t('shop-site::email::table_createTime') }}：{{ $dataCheck(row.createTime) }}</p>
            <p>{{ $t('shop-site::email::table_updateTime') }}：{{ $dataCheck(row.updateTime) }}</p>
          </template>
          <template #operate="{ row }">
            <el-button @click="handleBtn('edit', row)" type="text" v-auth="'stores::shop-site::email-edit'">
              {{ $t('shop-site::email::table_edit') }}
            </el-button>
            <el-button @click="handleSignBtn('edit', row)" type="text" v-auth="'stores::shop-site::email-sign'">
              {{ $t('shop-site::email::table_emailSign') }}
            </el-button>
          </template>
        </z-table>
      </el-card>
    </div>
    <div v-else>
      <emptyCard
        :data="{
          title: $t('after-sales::email-setting::empty_email_title'),
          img: require('@/assets/images/emptyDefault/ServiceEmail@2x.png'),
          desc: $t('after-sales::email-setting::empty_email_tips'),
          buttons: [
            {
              click: onBindEmail,
              text: $t('after-sales::email-setting::empty_bind_email'),
              auth: 'stores::shop-site::email-add',
            },
          ],
        }"
      ></emptyCard>
    </div>
    <emailModal v-model="drawerVisable" @save="onSave" :drawRow="drawRow"></emailModal>
    <emailSignModal v-model="signVisable" @save="onSave" :drawRow="drawSignRow"></emailSignModal>
  </div>
</template>
<script>
import moment from 'moment'
import emailModal from '../components/email-modal'
import emailSignModal from '../components/email-sign-modal'
import { getEmailInfoList, updateEmailInfoList } from '@/server/after-sales.js'
let num = 0
export default {
  name: 'email-list',
  components: {
    emailModal,
    emailSignModal,
  },
  // props: {
  //   params: {
  //     default: () => {}
  //   }
  // },
  data() {
    return {
      params: {
        email: '',
      },
      test: Array.from({ length: 10 }, (item, index) => ({ label: index, value: index })),
      drawerVisable: false,
      signVisable: false,
      drawSignRow: {
        type: 'add',
        item: {},
      },
      drawRow: {
        type: 'add',
        item: {},
      },
      tagList: [
        { label: '1', value: '1' },
        { label: '2', value: '2' },
      ],
      columns: [
        {
          prop: 'index',
          label: this.$t('shop-site::email::table_no'),
          fixed: 'left',
          minWidth: '80',
        },
        {
          prop: 'shopName',
          label: this.$t('shop-site::email::table_shop'),
          fixed: 'left',
          minWidth: '150',
        },
        {
          prop: 'inServer',
          label: this.$t('shop-site::email::table_recieve'),
          minWidth: '300',
        },
        {
          prop: 'outServer',
          label: this.$t('shop-site::email::table_send'),
          minWidth: '300',
        },
        {
          prop: 'status',
          label: this.$t('shop-site::email::table_status'),
          slotHeaderName: 'statusHeader',
          width: '160',
          align: 'center',
        },
        {
          prop: 'createTime',
          label: this.$t('shop-site::email::table_time'),
          width: '300',
        },

        {
          prop: 'operate',
          label: this.$t('shop-site::email::table_handle'),
          width: '180',
          fixed: 'right',
        },
      ],
      tableData: [],
      pagination: {
        pageNum: 1, // 页码
        pageSize: 10, // 每页大小
        total: 0,
      },
      loading: false,
      noMore: false,
    }
  },
  mounted() {
    if (this.hasBindData.isExistCs) this.initData(this.params, true)
  },
  methods: {
    onBindEmail() {
      this.handleBtn('add')
    },
    handleBtn(type, row) {
      this.drawRow.type = type
      if (row) this.drawRow.item = row
      this.drawerVisable = true
      if (type === 'add') {
        this.$store.dispatch('buried', { event: 'StoreManagementClick', buttonName: '新增邮箱' })
      }
    },
    handleSignBtn(type, row) {
      this.drawSignRow.type = type
      if (row) this.drawSignRow.item = row
      this.signVisable = true
    },
    initData(params) {
      this.getListData(params, true)
    },
    async onSave() {
      this.getListData(this.params)
      if (!this.hasBindData.isExistCs) await this.$store.dispatch('getBindData')
    },
    search(params) {
      this.getListData(params)
    },
    async getListData(params, reset = false) {
      if (reset) {
        // 回到第一页
        this.pagination.pageNum = 1
      }
      this.loading = true
      if (!params) {
        params = this.params
      }
      console.log(params)
      const { data } = await getEmailInfoList({
        ...params,
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
      })
      this.loading = false
      if (data.code === this.$code) {
        this.tableData = data.data.items.map((item, i) => {
          return {
            index: i + 1 + (this.pagination.pageNum - 1) * this.pagination.pageSize,
            ...item,
            status: Boolean(item.status),
          }
        })
        this.pagination.total = data.data.totalCount
      }
    },
    async onSwitchChange(row, status) {
      this.loading = true
      const { data } = await updateEmailInfoList({ accountId: row.id, status: Number(status) })
      this.loading = false
      if (data.code === this.$code) {
        this.$message.success(this.$t('system::tip::control_success'))
        this.getListData(this.params)
      }
    },
  },
  watch: {
    tableData(val, oldVal) {
      if (val.length === 0 && val.length !== oldVal.length) {
        this.$store.dispatch('getBindData')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-group {
  .btn-item {
    margin-left: 0;
    margin-right: 10px;
  }
}
</style>
